import React from 'react';
import MfaError from './mfaError';

import { MfaCodeInput } from '../../../../../components/Inputs';
import FormController from '../../../../../components/FormController';
import { useAuth } from '../../../../../hooks/useAuth';

const MFAForm = () => {
	const { confirmSignInWithTOTP } = useAuth();

	return (
		<FormController onSubmit={confirmSignInWithTOTP}>
			<MfaError />
			<MfaCodeInput id="mfaCode" />
		</FormController>
	);
};

MFAForm.propTypes = {};

export default MFAForm;
